export const templateOfTextImageBlock = `
    <p class="greytext--text">Enter an optional description here to explain the step in more detail...</p>
    <img class="custom-image large" src="/assets/editor_images/sample_image_1.jpg" />
`
